export default {
  name: 'ModalBody',
};
